import { Box } from '@base-app';
import { styled } from '@/stitches.config';

export const StyledViewOrderIdsFilter = styled(Box, {
  borderBottom: '$borderWidths$1 solid $colors$seafoam500',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$4',
  padding: '$4',
});

export const StyledDropdownFilters = styled(Box, { display: 'flex' });
